import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import './index.css';
import config from '../../config/config';

import img1 from '../../../src/images/patient-icon.svg'
import img2 from '../../../src/images/cross-icon.svg'
import img3 from '../../../src/images/analysis-profile.svg'
import img4 from '../../../src/images/calendar2.svg'
import img12 from '../../../src/images/3dots.svg'
import img5 from '../../../src/images/insights1.svg';
import img6 from '../../../src/images/insights2.svg'
import img7 from '../../../src/images/insights3.svg'
import img8 from '../../../src/images/insights4.svg'
import img9 from '../../../src/images/insights5.svg'
import img10 from '../../../src/images/insights6.svg'
import img11 from '../../../src/images/insights7.svg'
import img13 from '../../../src/images/arr-down.svg'
import img14 from '../../../src/images/patient-icon.svg'; // Patients Icon
import img15 from '../../../src/images/glucose-trends.svg'

import img16 from '../../../src/images/home2.svg';
import img17 from '../../../src/images/Icon (5).svg';
import img18 from '../../../src/images/notification.svg';
import img19 from '../../../src/images/Calendar3.svg';
import img20 from '../../../src/images/Icon (6).svg';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer,
    BarChart,
    Bar,
    Legend,
} from 'recharts';

function PatientInfo() {
    const navigate = useNavigate();
    const location = useLocation();
    const { patientName, patientAge, patientCondition, groomingProgress, appointmentDate, appointmentTimeslot } = location.state?.state || {};  const [patients, setPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [nextAppointment, setNextAppointment] = useState(null); // Declare nextAppointment state

    const [dailyGlucoseData, setDailyGlucoseData] = useState([]);
    const [timeRange, setTimeRange] = useState(7);
    const [dateRange, setDateRange] = useState('');
    const [selectedRange, setSelectedRange] = useState(7); // Default range is 7 days
    const backendURL = `${config.backendServerHost}`;


    // Place console.log statements to debug received state
    console.log('Received state:', location.state);
    console.log('Extracted Patient Name:', patientName);
    console.log('Extracted Patient Age:', patientAge);
    console.log('Extracted Patient Condition:', patientCondition);
    console.log('Extracted Patient Grooming status:', groomingProgress);
    console.log('Extracted Patient Appointment Date:', appointmentDate);
    console.log('Extracted Patient Appointment Timeslot:', appointmentTimeslot);

useEffect(() => {
    fetch(`${backendURL}/patients/api/patients`)
        .then((res) => res.json())
        .then((data) => {
            setPatients(data); // Store all patients
            const foundPatient = data.find(patient => patient.name === patientName); // Find patient by name
            if (foundPatient) {
                setSelectedPatient(foundPatient); // Set the selected patient
            } else {
                console.error(`Patient with name "${patientName}" not found.`);
            }
        })
        .catch((error) => console.error('Error fetching patients:', error));
}, [backendURL, patientName]);

 useEffect(() => {
        if (!patientName) return;

        // Fetch next appointment for the selected patient
        fetch(`${backendURL}/patients/api/appointments?patientName=${patientName}`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed to fetch appointment data');
                }
                return res.json();
            })
            .then((data) => {
                // Assuming the API returns the next appointment in `data.nextAppointment`
                setNextAppointment(data.date || 'No upcoming appointments');
            })
            .catch((error) => {
                console.error('Error fetching next appointment:', error);
                setNextAppointment('Error fetching appointment data');
            });
    }, [backendURL, patientName]);



const DailyGlucoseGraph = ({ patientId }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!patientId) return;

        setLoading(true);

        fetch(`${backendURL}/patients/api/glucose-weekly-average/${patientId}?range=${selectedRange}`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Failed to fetch glucose data");
                }
                return res.json();
            })
            .then((response) => {
                if (!response.lastNDaysAverages || !Array.isArray(response.lastNDaysAverages)) {
                    throw new Error("Invalid data format");
                }

const sortedData = response.lastNDaysAverages
    .map(({ day, average }) => {
        const [month, date] = day.split('/').map(Number);
        // Determine the year based on the month (handle year rollover)
        const year = month === 12 ? 2024 : 2025;
        return {
            day, // Keep MM/DD format for display
            glucose: parseFloat(average),
            dateObj: new Date(year, month - 1, date), // Create a Date object for sorting
        };
    })
    .sort((a, b) => a.dateObj - b.dateObj) // Sort by actual Date objects
    .map(({ day, glucose }) => ({ day, glucose })); // Remove extra properties

                setData(sortedData);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Data Fetch Error:", err);
                setError(err.message);
                setLoading(false);
            });
    }, [patientId, selectedRange]);

    if (loading) return <div>Loading Daily Glucose Data...</div>;
    if (error) return <div>Error: {error}</div>;
    if (!data || data.length === 0) return <div>No glucose data available</div>;

    return (
        <div className="daily-glucose-graph">
            <h2>Daily Glucose Trends</h2>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
<XAxis
    dataKey="day"
    label={{ value: "Day", position: "insideBottomRight", offset: 0 }}
    tickFormatter={(tick) => tick} // Keeps MM/DD format
/>
                    <YAxis
                        domain={[0, 200]}
                        label={{ value: "Glucose (mg/dL)", angle: -90, position: "insideLeft" }}
                    />
                    <Tooltip />
                    <Line
                        type="monotone"
                        dataKey="glucose"
                        stroke="#8884d8"
                        name="Average Glucose"
                        dot={{ r: 5 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

const InsulinBarGraph = ({ patientId, selectedRange }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

useEffect(() => {
    if (!patientId || !selectedRange) return;

    setLoading(true);
    setError(null); // Reset error state before fetching

    fetch(`${backendURL}/patients/api/insulin-weekly-breakdown/${patientId}?range=${selectedRange}`)
        .then((response) => {
            if (!response.ok) {
                throw new Error("Failed to fetch insulin data");
            }
            return response.json();
        })
        .then((responseData) => {
            // Validate and process the response data
            if (
                responseData &&
                responseData.insulinBreakdown &&
                Array.isArray(responseData.insulinBreakdown)
            ) {
                // Assume current year if year is not provided
                const currentYear = new Date().getFullYear();

                // Convert `month/day` to `month/day/year` and sort data
                const sortedData = responseData.insulinBreakdown.map((entry) => ({
                    ...entry,
                    fullDate: new Date(`${entry.day}/${currentYear}`), // Add year for parsing
                })).sort((a, b) => a.fullDate - b.fullDate);

                setData(sortedData);
            } else {
                throw new Error("Invalid insulin data format");
            }
            setLoading(false);
        })
        .catch((err) => {
            setError(err.message || "An error occurred while fetching insulin data");
            setLoading(false);
        });
}, [patientId, selectedRange]);

    if (loading) return <div>Loading Insulin Data...</div>;
    if (error) return <div>Error: {error}</div>;
    if (!data || data.length === 0) return <div>No insulin data available</div>;

    return (
        <div className="insulin-bar-graph">
            <h2>Insulin Breakdown ({selectedRange} Range)</h2>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="day" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="basal" fill="#8884d8" name="Basal Insulin" />
                    <Bar dataKey="bolus" fill="#82ca9d" name="Bolus Insulin" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};


    const handleRangeChange = (event) => {
        setSelectedRange(parseInt(event.target.value, 10));
    };

    const calculateDateRange = () => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(endDate.getDate() - selectedRange);
        const options = { month: 'short', day: 'numeric' };

        return `${startDate.toLocaleDateString('en-US', options)} - ${endDate.toLocaleDateString('en-US', options)}`;
    };

  const navigateTo = (path, state = {}) => {
  navigate(path, { state });
};


    return (
        <div className="dashboard_container ai-analysis-container">
            <div className='patient-navbar'>
                <div></div>
                <div className='patient-icon'>
                <img src={img1} alt="" /><span>Patient</span></div>
                <div><img src={img2} alt="" /></div>
            </div>
            <div className='patient_info_card'>
                <div className='patient_info_content'>
                    <div><img src={img3} alt="" /></div>
                    <div>
                        <h3>{patientName}</h3>
                        <h4>Age: {patientAge}<br />Condition: {patientCondition}</h4>
                    </div>
                </div>

                <div className='ai-analysis-wrapper patient_buttons'>
                    <div className='aianalysis-btn3'><button>Call</button></div>
                    <div className='aianalysis-btn3'><button>SMS</button></div>
                </div>
            </div>

            <div className='appointment-content'>
                <div className='appointment-text'>
                    <div><img src={img4} alt="" /></div>
                    <div>
                        <h3>Next appointment:</h3>
                        <h4>
                            {appointmentDate && appointmentTimeslot ? `${appointmentDate} at ${appointmentTimeslot}` : 'No upcoming appointments'}
                        </h4>
                    </div>
                </div>
                <div>
                    <img src={img12} alt="" />
                </div>
            </div>


            <div className='quick-insights-heading2'>
                <div><h3>Quick insights</h3></div>
                <div className='arr-down'>
                    {/* Date Range */}
                    <div className="header">
                    <select  className='days-select' onChange={handleRangeChange} value={selectedRange}>
                        <option value={7}>7 Days</option>
                        <option value={14}>14 Days</option>
                        <option value={30}>30 Days</option>
                    </select>
                     </div>

                </div>
            </div>


            <div className='cards_slider analysis-card-slider'>
                <div className='cards_container'>

                    <div className='cards_wrapper ai-cards-wrapper' 
                    onClick={() =>
                        navigate('/glucoselevel', {
                            state: {
                                patientName: selectedPatient?.name,
                                patientAge: selectedPatient?.age,
                                patientCondition: selectedPatient?.type,
                                patientId: selectedPatient?.id,
                            },
                        })
                    }
                >
                        <img src={img5} alt="Analysis Icon" />
                        <h2>Avg glucose<br /><span>138 mg/dL</span></h2>
                        <div className='bottom_line'></div>
                        <div className='card_wrapper_bottom'>
                            <div className='pending_text'>
                                <h5>Reduced</h5>
                                <h6>27 mg/dL</h6>
                            </div>
                            <div className='confirmed_text'>
                                <h5>Decrease</h5>
                                <h6>16%</h6>
                            </div>
                        </div>
                    </div>

                    <div className='cards_wrapper ai-cards-wrapper' 
                    onClick={() => 
                        navigate('/insulinusage', {
                            state: {
                                patientName: selectedPatient?.name,
                                patientAge: selectedPatient?.age,
                                patientCondition: selectedPatient?.type,
                                patientId: selectedPatient?.id,
                            },
                        })
                    }
                    >

                        <img src={img6} alt="Appointments Icon" />
                        <h2>Insulin levels<br /><span>32 units</span></h2>
                        <div className='bottom_line'></div>
                        <div className='card_wrapper_bottom'>
                            <div className='pending_text'>
                                <h5>Basal</h5>
                                <h6>24u</h6>
                            </div>
                            <div className='confirmed_text'>
                                <h5>Bolus</h5>
                                <h6>8u</h6>
                            </div>
                        </div>
                    </div>
                    <div className='cards_wrapper ai-cards-wrapper' 
                    onClick={() => 
                        navigate('/timeinrange', {
                            state: {
                                patientName: selectedPatient?.name,
                                patientAge: selectedPatient?.age,
                                patientCondition: selectedPatient?.type,
                                patientId: selectedPatient?.id,
                            },
                        })
                    }
                    >

                        <img src={img7} alt="Appointments Icon" />
                        <h2>Time in Range<br /><span>32 units</span></h2>
                        <div className='bottom_line'></div>
                        <div className='card_wrapper_bottom'>
                            <div className='pending_text'>
                                <h5>Basal</h5>
                                <h6>24u</h6>
                            </div>
                            <div className='confirmed_text'>
                                <h5>Bolus</h5>
                                <h6>8u</h6>
                            </div>
                        </div>
                    </div>
                    <div className='cards_wrapper ai-cards-wrapper' 
                    onClick={() => 
                        navigate('/events', {
                            state: {
                                patientName: selectedPatient?.name,
                                patientAge: selectedPatient?.age,
                                patientCondition: selectedPatient?.type,
                                patientId: selectedPatient?.id,
                            },
                        })
                    }
                    >
                        <img src={img8} alt="Appointments Icon" />
                        <h2>Events<br /><span>32 units</span></h2>
                        <div className='bottom_line'></div>
                        <div className='card_wrapper_bottom'>
                            <div className='pending_text'>
                                <h5>Basal</h5>
                                <h6>24u</h6>
                            </div>
                            <div className='confirmed_text'>
                                <h5>Bolus</h5>
                                <h6>8u</h6>
                            </div>
                        </div>
                    </div>
                    <div className='cards_wrapper ai-cards-wrapper' onClick={() => navigate('/patientinfo')}>
                        <img src={img9} alt="Appointments Icon" />
                        <h2>Meal Impact<br /><span>32 units</span></h2>
                        <div className='bottom_line'></div>
                        <div className='card_wrapper_bottom'>
                            <div className='pending_text'>
                                <h5>Basal</h5>
                                <h6>24u</h6>
                            </div>
                            <div className='confirmed_text'>
                                <h5>Bolus</h5>
                                <h6>8u</h6>
                            </div>
                        </div>
                    </div>
                    <div className='cards_wrapper ai-cards-wrapper' onClick={() => navigate('/patientinfo')}>
                        <img src={img10} alt="Appointments Icon" />
                        <h2>Exercise Effect<br /><span>32 units</span></h2>
                        <div className='bottom_line'></div>
                        <div className='card_wrapper_bottom'>
                            <div className='pending_text'>
                                <h5>Basal</h5>
                                <h6>24u</h6>
                            </div>
                            <div className='confirmed_text'>
                                <h5>Bolus</h5>
                                <h6>8u</h6>
                            </div>
                        </div>
                    </div>
                    <div className='cards_wrapper ai-cards-wrapper' onClick={() => navigate('/patientinfo')}>
                        <img src={img11} alt="Appointments Icon" />
                        <h2>Diet Balance<br /><span>32 units</span></h2>
                        <div className='bottom_line'></div>
                        <div className='card_wrapper_bottom'>
                            <div className='pending_text'>
                                <h5>Basal</h5>
                                <h6>24u</h6>
                            </div>
                            <div className='confirmed_text'>
                                <h5>Bolus</h5>
                                <h6>8u</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className='breakdown-heading'>
                <h2>Glucose Trands</h2>
            </div>
<div className='glucose-trends-image'>
    {selectedPatient ? (
        <DailyGlucoseGraph patientId={selectedPatient.id} />
    ) : (
        <div>No patient data available to display glucose trends</div>
    )}
</div>


            <div className='breakdown-heading'>
                <h2>Insulin Breakdown</h2>
            </div>

<div className='insulin-breakdown-image'>
    {selectedPatient ? (
        <InsulinBarGraph patientId={selectedPatient.id} selectedRange={selectedRange} />
    ) : (
        <div>No patient data available to display insulin breakdown</div>
    )}
</div>

            <div className='bottom-line-insights'></div>
            <div className='summary-text'>
                <h2>Summary of Key Metrics</h2>
                <p>- Average Glucose: 145 mg/dL (current month)<br /> &nbsp;&nbsp;&nbsp;— Trend: 7 mg/dL improvement<br />
                    - Time in Range: 68% (target: 70%)<br />
                    - Hypoglycemic Episodes: 3 in the past week<br />
                    - Hyperglycemic Episodes: 4 in the past week<br />
                    - Daily Insulin Usage: 24 units basal, 16 units bolus</p>
            </div>
            <div className='insights_content'>
                <h2>Time in Range (TIR)</h2>
                <p>Current TIR: 68%, slightly below the target of 70%.<br /><br />
                    Recommendation: Consider a modest increase in basal insulin for late afternoon to reduce pre-dinner spikes, aiming to bring TIR closer to target.<br /><br />
                    Next Steps: Adjust Afternoon Basal Insulin</p>
            </div>
            <div className='insights_content'>
                <h2>Hypoglycemia</h2>
                <p>Hypoglycemia: Linked to weekend exercise sessions.
                    <br /><br />
                    Hyperglycemia: Most frequent after dinner.
                    <br /><br />
                    Recommendation: Encourage Victor to have a 15g carb snack before exercise to prevent lows. Evaluate dinner bolus timing for more effective glucose control.
                    <br /><br />
                    Next Steps: Recommend Pre-Exercise Snack and Review Evening Bolus Timing</p>
            </div>
            <div className='insights_content'>
                <h2>Insulin Usage Patterns</h2>
                <p>Current Dosage Balance: Basal 24 units, Bolus 16 units — balanced, but small adjustments suggested.
                    <br /><br />
                    Recommendation: Decrease morning basal by 1–2 units and increase pre-lunch bolus to reduce mid-day glucose peaks.
                    <br /><br />
                    Next Steps: Modify Basal & Bolus Doses</p>
            </div>
            <div className='insights_content'>
                <h2>Exercise and Meal Impacts</h2>
                <p>Exercise Impact: Notable drop in glucose after exercise, especially on weekends.
                    <br /><br />
                    Meal Impact: Glucose spikes observed post-lunch and dinner.
                    <br /><br />
                    Recommendation: Work with Victor to refine pre-meal insulin and review carbohydrate ratios, particularly for dinner.
                    <br /><br />
                    Next Steps: Carbohydrate Ratio Review
                    </p>
            </div>
            <div className='insights_content'>
                <h2>Diet Balance</h2>
                <p>Observation: Current diet may cause variability in glucose control. 
                    <br /><br />
                    Recommendation: Suggest more low-glycemic foods to stabilize glucose levels and refer Victor to a dietitian for ongoing support.
                    <br /><br />
                    Next Steps: Dietitian Referral for long-term dietary adjustments.
                    </p>
            </div>


            <div className='analysis-footer-wrapper'>
                <div className='ai-analysis-footer'>
                    <div className='ai-analysis-footer-btn' 
                    onClick={() => navigateTo('/billingreport', { state: { patientName } })}>Generate Billing Report</div>
 
                    <p>Generate  billing reports for  individual patients.</p>
                </div>
            </div>


            <div className="footer_container_wrapper">
                <div className="footer_container">
                    <div className="footer_icon" onClick={() => navigate('/dashboard-page')}>
                        <img src={img16} alt="Home Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/analysis')}>
                        <img src={img17} alt="Analytics Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/alerts')}>
                        <img src={img18} alt="Notification Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/appointments')}>
                        <img src={img19} alt="Calendar Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/Aianalysis1')}>
                        <img src={img14} alt="Patient Icon" />
                    </div>
                </div>
            </div>


        </div>
    );
}

export default PatientInfo;
